import React from 'react';
import BettingHistoryResults from 'features/Big9History/BettingHistoryResults';
import Text from 'ui/Text';
import { detectMobile, formatDenmarkCurrency } from 'utils/UiHelper';
import Button from 'ui/Button';
import ReactTooltip from 'react-tooltip';

const CouponResults = ({ coupon }) => {
    const getTurnover = (winInfo) =>
        winInfo
            .map(
                (info) =>
                    `<p><span>${info.numberOfCorrect} rigtige</span> <span>${
                        info.numberOfCoupons
                    } = ${formatDenmarkCurrency(info.amount)} kr.</span></p>`
            )
            .join('');

    return (
        <>
            {coupon.betWasPlaced ? (
                <div className={coupon.winAmount > 0 && 'win-result-wrapper'}>
                    <BettingHistoryResults
                        spilklub
                        winResults
                        win={coupon.winAmount > 0}
                        coupon
                        amount={coupon.userWinAmount}
                        amountWin={coupon.winAmount}
                    />
                    {coupon.winAmount > 0 &&
                        coupon.winInfo && (
                            <div className={'flex flex-row-reverse'}>
                                <Text
                                    size={'x07'}
                                    color={'#333'}
                                    align={'right'}
                                    condensed
                                    flex={'0 0 100px'}
                                    decoration={'underline'}
                                    padding={'5px 10px 5px 0'}
                                    width={'100px'}
                                    data-tip={getTurnover(coupon.winInfo)}
                                    data-place="bottom"
                                    data-effect={'solid'}
                                    data-event={detectMobile() ? 'click' : ''}
                                    data-html={true}
                                >
                                    Vis gevinst rækker
                                </Text>
                            </div>
                        )}
                </div>
            ) : (
                <div className={'flex'}>
                    <Button neutral className="flex-grow" margin={'0'}>
                        <Text
                            size={'x1'}
                            color={'#333'}
                            condensed
                            align={'center'}
                            bold
                            padding={'2px 0'}
                        >
                            Kuponen blev ikke placeret
                        </Text>
                    </Button>
                </div>
            )}
            <ReactTooltip
                border={false}
                showTabSwitcher={false}
                container="srf-widget"
                className="tooltip big9 turnover-tooltip"
                type="dark"
                place="top"
                backgroundColor="#333333"
                globalEventOff="click"
            />
        </>
    );
};

export default CouponResults;
